<template>
	<table class="table">
		<tbody>
			<ShowcaseRow
				:showcase="showcase"
				v-for="showcase in showcases"
				v-bind:key="showcase.id"
			></ShowcaseRow>
		</tbody>
	</table>
</template>

<script>
	import ShowcaseRow from "./ShowcaseRow";

	export default {
		name: "VideoTable",
		components: { ShowcaseRow },
		props: {
			showcases: {
				type: Array,
				required: true
			}
		}
	};
</script>
